import { createSlice } from "@reduxjs/toolkit";

interface Props {
  data: any
}

const initialState: Props = {
  data: {}
}

export const RequestHeaderSlice = createSlice({
  name: "reuqestHeader",
  initialState,
  reducers: {
    saveRequestHeaderData: (state, action) => {
      state.data = action.payload
    },
    resetRequestHeaderData: (state) => {
      state.data = {}
    }
  }
});

export const {
  saveRequestHeaderData,
  resetRequestHeaderData,
} = RequestHeaderSlice.actions;

export default RequestHeaderSlice.reducer;
